import { selectIsEtazhiBlackFridayEnabled } from './selectIsEtazhiBlackFridayEnabled';
import { getIsFlatSale, getIsRoomSale } from '../../utils/etazhiBlackFriday';
import { selectJsonQuery } from '../results';

import type { IAppState } from 'shared/common/state';

/**
 * Вернёт признак того, видим ли функционал ЧП в принципе.
 * Если РС выключена, не вторичка/(квартиры-комнаты), то ЧП не должен работать.
 */
export const selectIsEtazhiBlackFridayPromoVisible = (state: IAppState): boolean => {
  const isProjectEnabled = selectIsEtazhiBlackFridayEnabled(state);

  if (!isProjectEnabled) {
    return false;
  }

  const jsonQuery = selectJsonQuery(state);

  // Только вторичка продажа квартир
  const isFlatSale = getIsFlatSale(jsonQuery);
  const isRoomSale = getIsRoomSale(jsonQuery);

  return isFlatSale || isRoomSale;
};
